import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { FormattedMessage } from 'react-intl';

import { Pluggable } from '@folio/stripes/core';

const InventoryOtherSettings = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      redirectTo="other-settings"
    >
      <FormattedMessage id="ui-inventory.templatesPluginNotAvailable" />
    </Pluggable>
  );
};

InventoryOtherSettings.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default InventoryOtherSettings;
